/* eslint-disable */
import _ from 'lodash';
import axios from 'axios';
import {
  fieldSubscriberDetailsRateplanCost,
  fieldSubscriberDetailsTier,
  fieldSubscriberDetailsDevices,
  fieldSubscriberDetailsBibProgram,
  fieldSubscriberDetailsBibCredit,
  fieldSubscriberDetailsDevicePlan,
  fieldSubscriberDetailsDeviceCredit,
  fieldSubscriberDetailsRateplanName,
  fieldSubscriberDetailsDeviceEnrolmentProgram,
  subscriberDetailsIsSimRequiredDevicesAccessories,
  provincesTaxPercentageMap,
  subscriberDetailsEasyPaymentAmount,
  subscriberDetailsUpfrontCost,
  subscriberDetailsTaxes,
  englishDevicePlanCategoryValues,
  frenchDevicePlanCategoryValues,
  englishTierValues,
  frenchTierValues,
  englishCPOCategoryValues,
  frenchCPOCategoryValues,
  englishProvinceValues,
  frenchProvinceValues,
  fieldSubscriberDetailsContractTerm,
  englishContractTermValues,
  frenchContractTermValues,
  canadianProvinceTaxKeys,
  canadianProvinceTaxKeysDevices,
  canadianProvinceTaxKeysDevicesThreeYear,
  DevicesOnlyEnglish,
  DevicesOnlyFrench,
  contractTerm3Year,
  fieldSubscriberDetailsTypeOfDevice,
  fieldSubscriberDetailsThreeYearHardwareCredits,
  fieldSubscriberDetailsThreeYearTier
} from '../../utils/constant';
import { isJson } from '../../utils/utils';
import { config, apiHost } from '../../utils/request';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const {
  contentfulValues: {
    wirelessOrderDetails: {
      simRequired: simRequiredEnglish,
      eSimRequired: eSimRequiredEnglish,
      valueTwoYear: valueTwoYearEnglish,
      valueThreeYear: valueThreeYearEnglish,
      valueVoiceOnly: valueVoiceOnlyEnglish,
      valueBasicEasyPayment: valueBasicEasyPaymentEnglish
    }
  }
} = EN;

const {
  contentfulValues: {
    wirelessOrderDetails: {
      simRequired: simRequiredFrench,
      valueTwoYear: valueTwoYearFrench,
      valueThreeYear: valueThreeYearFrench,
      eSimRequired: eSimRequiredFrench,
      valueVoiceOnly: valueVoiceOnlyFrench,
      valueBasicEasyPayment: valueBasicEasyPaymentFrench
    }
  }
} = FR;
const contractTermTwoYearValueVariants = [
  valueTwoYearEnglish,
  valueTwoYearFrench
];
const contractTermThreeYearValueVariants = [
  valueThreeYearEnglish,
  valueThreeYearFrench
];
const devicePlanVoiceOnlyValueVariants = [
  valueVoiceOnlyEnglish,
  valueVoiceOnlyFrench
];

const basicEasyPaymentVariants = [
  valueBasicEasyPaymentEnglish,
  valueBasicEasyPaymentFrench
];

const getFieldValue = (fields, field) => _.get(fields, `${field}.value`, '');

export const getCategories = (options, valueContractTerm, translations) => {
  const {
    contentfulValues: {
      wirelessOrderDetails: {
        valueByod,
        valueTwoYear,
        valueOwnersAdvantagePlan,
        valueDevicePurchaseMtm,
        valueByodSmartphone,
        valueByodMtmTablet,
        valueByodMtmWatch,
        valueByodMtmTelusDrivePlus,
        valueVoiceOnly,
        valueUnlimitedForBusiness
      }
    },
    localTranslations: {
      valueTablet,
      valueWatch,
      valueMobileHighSpeedSmartHub,
      valueThreeYear,
      valueBasicEasyPayment,
      valueBusinessSharePro,
      valueEasyPayment
    }
  } = translations;

  let categoryList;

  if (valueContractTerm === valueByod) {
    categoryList = options.filter(item =>
      [
        valueByodSmartphone,
        valueByodMtmTablet,
        valueByodMtmWatch,
        valueByodMtmTelusDrivePlus
      ].includes(item.fields.value)
    );
  } else if (valueContractTerm === valueTwoYear) {
    categoryList = options.filter(item =>
      [
        valueVoiceOnly,
        valueUnlimitedForBusiness,
        valueTablet,
        valueWatch,
        valueMobileHighSpeedSmartHub
      ].includes(item.fields.value)
    );
  } else if (valueContractTerm === valueThreeYear) {
    categoryList = options.filter(item =>
      [
        valueBasicEasyPayment,
        valueBusinessSharePro,
        valueEasyPayment,
        valueTablet,
        valueWatch,
        valueMobileHighSpeedSmartHub
      ].includes(item.fields.value)
    );
  } else if (valueContractTerm === valueOwnersAdvantagePlan) {
    categoryList = options.filter(item =>
      [valueUnlimitedForBusiness].includes(item.fields.value)
    );
  } else if (valueContractTerm === valueDevicePurchaseMtm) {
    categoryList = options.filter(item =>
      [valueMobileHighSpeedSmartHub].includes(item.fields.value)
    );
  }
  return categoryList;
};

const getSelectedContractTermKey = term => {
  return englishContractTermValues.find((item, index) => {
    if ([item, frenchContractTermValues[index]].includes(term)) {
      return englishContractTermValues[index];
    }
    return null;
  });
};

const getSelectedCategoryKey = category => {
  const foundCategory = englishDevicePlanCategoryValues.find((item, index) => {
    if ([item, frenchDevicePlanCategoryValues[index]].includes(category)) {
      return englishDevicePlanCategoryValues[index];
    }
    return null;
  });
  return foundCategory;
};

const getSelectedProvinceKey = province => {
  return englishProvinceValues.find((item, index) => {
    if ([item, frenchProvinceValues[index]].includes(province)) {
      return englishProvinceValues[index];
    }
    return null;
  });
};

const getSelectedTierKey = tier => {
  return englishTierValues.find((item, index) => {
    if ([item, frenchTierValues[index]].includes(tier)) {
      return englishTierValues[index];
    }
    return null;
  });
};

const getSelectedCPOCategoryKey = cpoCategory => {
  return englishCPOCategoryValues.find((item, index) => {
    if ([item, frenchCPOCategoryValues[index]].includes(cpoCategory)) {
      return englishCPOCategoryValues[index];
    }
    return null;
  });
};

const getTotalWithProvinceTaxPercentage = (province, basePrice) => {
  if (provincesTaxPercentageMap[province]) {
    return basePrice + (basePrice * provincesTaxPercentageMap[province]) / 100;
  }
  return basePrice;
};

export const getDevices = async ({
  vCategory,
  vIsCOP,
  vTier,
  vProvince,
  vCpoCategory,
  vContractTerm,
  vIsBIB,
  vHardwareCredit
}) => {
  const category = vCategory ? getSelectedCategoryKey(vCategory) : null; 
  const province = vProvince ? getSelectedProvinceKey(vProvince) : null;
  const tier = vTier ? getSelectedTierKey(vTier) : null;
  const contractTerm = vContractTerm
    ? getSelectedContractTermKey(vContractTerm)
    : null;
  const cpoCategory = vCpoCategory
    ? getSelectedCPOCategoryKey(vCpoCategory)
    : null;
  const hardwareCredit = vHardwareCredit ? vHardwareCredit : null;
  const isCOP = vIsCOP || false;
  const isBIB = vIsBIB || false;
  const res = await axios.get(`${apiHost}/devices/`, {
    ...config(),
    params: {
      category,
      province,
      isCOP,
      tier,
      cpoCategory: isCOP ? cpoCategory : ``,
      contractTerm,
      isBIB,
      hardwareCredit
    }
  });
  if (res && res.data && res.data.data && res.data.data.rows) {
    return res.data.data.rows.map(r => ({
      fields: {
        label: r.device_name || r.name || r.device,
        value: JSON.stringify({ ...r })
      }
    }));
  }
  return [];
};

export const getDeviceName = deviceDetail => {
  if (!deviceDetail) return 'BYOD';
  return deviceDetail.device_name;
};

export const getColorOptions = colors =>
  colors.split('/').map(color => {
    return {
      fields: {
        label: _.trim(color),
        value: _.trim(color)
      }
    };
  });

export const resetFeidValue = (formFields, resetFields) =>
  resetFields.reduce((acc, field) => {
    acc[field] = {
      ...formFields[field],
      value: ''
    };
    return acc;
  }, {});

// const getMultiUnitDiscount = (province, value) => {
//   const discount = ['Quebec', 'Manitoba', 'Saskatchewan'].includes(province)
//     ? {
//         '': 0,
//         1: 0,
//         2: 10,
//         3: 15,
//         '4-9': 20,
//         '10-15': 20,
//         '16-24': 20,
//         '25-49': 20,
//         '50+': 20
//       }
//     : {
//         '': 0,
//         1: 0,
//         2: 10,
//         3: 15,
//         '4-9': 20,
//         '10-15': 25,
//         '16-24': 30,
//         '25-49': 32,
//         '50+': 35
//       };
//   return discount[value];
// };

export const getTierCode = fields => {
  const valueTier =
    getFieldValue(fields, fieldSubscriberDetailsTier) ||
    getFieldValue(fields, fieldSubscriberDetailsThreeYearTier);

  const tierCode = {
    'Low Up Front': 'LUEP',
    'Acompte réduit': 'LUEP',
    'Zero Up Front': 'ZUEP',
    'Aucun acompte': 'ZUEP',
    'Low Monthly': 'LMEP',
    'Mensualités réduites': 'LMEP',
    'Standard-Zero Upfront': 'LUEP',
    'Essentiel – Aucun acompte': 'LUEP',
    // 2-year term tiers renamed from Select/Complete-* to Standard Plus/Complete-* (keep old keys for backward compatibility)
    'Select/Complete-Zero Upfront': 'ZUEP',
    'Select/Complete-Low Monthly': 'LMEP',
    'Standard Plus/Complete-Zero Upfront': 'ZUEP',
    'Standard Plus/Complete-Low Monthly': 'LMEP',
    'Aucun acompte Essentiel Plus et Complet': 'ZUEP',
    'Mensualités réduites Essentiel Plus et Complet': 'LMEP',
  };
  return tierCode[valueTier];
};

const getKeyWithRespectToProvince = (orderData, tierCode, category = null) => {
  const valueProvince = getSelectedProvinceKey(orderData.provinceWLS || '');
  let provinceTaxKey = '';
  let map = canadianProvinceTaxKeys;
  switch (category) {
    case 'Watch':
      map = canadianProvinceTaxKeysDevices;
      break;
    case 'Tablet':
      map = canadianProvinceTaxKeysDevices;
      break;
    case 'Mobile High Speed/SmartHub':
      map = canadianProvinceTaxKeysDevices;
      break;
    case '3 year':
      map = canadianProvinceTaxKeysDevicesThreeYear;
      break;
    default:
      map = canadianProvinceTaxKeys;
  }

  Object.keys(map).forEach(key => {
    if (key === valueProvince) provinceTaxKey = map[key][tierCode];
  });
  return provinceTaxKey;
};

export const calculateTotal = (
  translations,
  fields,
  subscriberDetails,
  accessories,
  features,
  deviceCare,
  setTotal,
  editingSubscriber,
  orderData,
  deviceCareBYOD
) => {
  let rateplanTotal = 0;
  let easyPaymentTotal = 0;
  let deviceUpfrontTotal = 0;
  let deviceSalesTax = 0;
  let totalMonthly = 0;
  let totalOneTime = 0;
  let deviceEnrolmentProgram = 0;
  let accessoriesPrice = 0;
  let simPrice = 0;
  let deviceUpfrontCost = 0;
  let taxes = 0;
  const dueNowList = [];
  const dueMonthlyList = [];

  const {
    contentfulValues: {
      yes,
      wirelessOrderDetails: {
        valueDevicePurchaseMtm,
        valueUnlimitedForBusiness,
        valueTablet,
        valueWatch,
        valueMobileHighSpeedSmartHub,
        valueTwoYear
      }
    }
  } = translations;

  const isDevicesOnly =
    orderData &&
    orderData.orderNotEligibleforMssReason &&
    (orderData.orderNotEligibleforMssReason.includes(DevicesOnlyEnglish) ||
      orderData.orderNotEligibleforMssReason.includes(DevicesOnlyFrench));

  // const valueOfferCode = getFieldValue(fields, fieldSubscriberDetailsOfferCode);
  // const valueValidationCode = getFieldValue(
  //   fields,
  //   fieldSubscriberDetailsValidationCode
  // );
  const valueContractTerm = getFieldValue(
    fields,
    fieldSubscriberDetailsContractTerm
  );
  const valueRatePlanName = getFieldValue(
    fields,
    fieldSubscriberDetailsRateplanName
  );
  const valueRatePlanCost = +getFieldValue(
    fields,
    fieldSubscriberDetailsRateplanCost
  );
  const valueDevicePlan = getFieldValue(
    fields,
    fieldSubscriberDetailsDevicePlan
  );
  const valueTypeOfDevice = getFieldValue(
    fields,
    fieldSubscriberDetailsTypeOfDevice
  );
  const valueDeviceDetails = getFieldValue(
    fields,
    fieldSubscriberDetailsDevices
  );
  const valueThreeYearHardwareCredit = getFieldValue(
    fields,
    fieldSubscriberDetailsThreeYearHardwareCredits
  );
  const valueDevice =
    valueDeviceDetails && isJson(valueDeviceDetails)
      ? JSON.parse(valueDeviceDetails)
      : valueDeviceDetails;
  const valueDeviceCredit = getFieldValue(
    fields,
    fieldSubscriberDetailsDeviceCredit
  );

  const valueDeviceEnrolment = getFieldValue(
    fields,
    fieldSubscriberDetailsDeviceEnrolmentProgram
  );

  const valueIsSimRequiredDevicesAccessories = getFieldValue(
    fields,
    subscriberDetailsIsSimRequiredDevicesAccessories
  );

  const valueBibProgram = getFieldValue(
    fields,
    fieldSubscriberDetailsBibProgram
  );
  const valueBibCredit = getFieldValue(fields, fieldSubscriberDetailsBibCredit);

  const valueEasyPaymentAmount = getFieldValue(
    fields,
    subscriberDetailsEasyPaymentAmount
  );

  const valueUpfrontCost = getFieldValue(fields, subscriberDetailsUpfrontCost);

  const valueTaxes = getFieldValue(fields, subscriberDetailsTaxes);
  /**
   * ADDING RATE PLAN COST AND GIVING ADDITIONAL 10% OFF THE RATE PLAN IF SPECIAL OFFER IS APPLIED
   */
  // Giving additional 10% discount is removed now
  if (valueDevicePlan === valueUnlimitedForBusiness) {
    if (valueRatePlanCost) {
      rateplanTotal = valueRatePlanCost;
    }
  } else {
    rateplanTotal = valueRatePlanCost;
  }
  if (valueRatePlanCost) {
    dueMonthlyList.push({
      name: valueRatePlanName,
      price: valueRatePlanCost,
      type: 'ADD'
    });
  }

  if (valueDevice) {
    if (
      [valueTablet, valueWatch, valueMobileHighSpeedSmartHub].includes(
        valueDevicePlan
      ) &&
      valueContractTerm !== valueDevicePurchaseMtm
    ) {
      /**
       * Calculating Easy Payment Cost
       */
      if (contractTermThreeYearValueVariants.includes(valueContractTerm)) {
        easyPaymentTotal = +_.get(valueDevice, 'monthly_repayment_3yr', 0);
      } else {
        easyPaymentTotal = +_.get(valueDevice, 'monthly_repayment_2yr', 0);
      }
      dueMonthlyList.push({
        name: 'Easy Payment',
        price: easyPaymentTotal,
        type: 'ADD'
      });
      /**
       * Subtracting easypayment * 24monts price
       * from the Due now summary
       */
      if (contractTermThreeYearValueVariants.includes(valueContractTerm)) {
        dueNowList.push({
          name: 'Easy Payment',
          price: (easyPaymentTotal * 36).toFixed(),
          type: 'SUB'
        });
      } else {
        dueNowList.push({
          name: 'Easy Payment',
          price: (easyPaymentTotal * 24).toFixed(),
          type: 'SUB'
        });
      }
      // Device Upfront Cost
      if (contractTermThreeYearValueVariants.includes(valueContractTerm)) {
        deviceUpfrontTotal = +_.get(valueDevice, 'upfront_cost_3yr', 0);
      } else {
        deviceUpfrontTotal = +_.get(valueDevice, 'upfront_cost_2yr', 0);
      }
      dueNowList.push({
        name: _.get(valueDevice, 'device_name', ''),
        price: deviceUpfrontTotal,
        type: 'ADD'
      });
      /**
       * Calculating Device Sales Tax
       */
      var provinceKey = getKeyWithRespectToProvince(
        orderData,
        'ZUEP',
        valueDevicePlan
      );
      if (contractTermThreeYearValueVariants.includes(valueContractTerm)) {
        provinceKey = provinceKey + '_3yr';
      }
      deviceSalesTax = +_.get(valueDevice, provinceKey, 0);
      dueNowList.push({
        name: 'Device Sales Tax',
        price: deviceSalesTax,
        type: 'ADD'
      });
    } else if (
      valueContractTerm === valueDevicePurchaseMtm &&
      [valueMobileHighSpeedSmartHub].includes(valueDevicePlan)
    ) {
      // Device Upfront Cost
      deviceUpfrontTotal = +_.get(valueDevice, 'mtmprice', 0);
      dueNowList.push({
        name: _.get(valueDevice, 'device_name', ''),
        price: deviceUpfrontTotal,
        type: 'ADD'
      });
      /**
       * Calculating Device Sales Tax
       */
      var provinceKey = getKeyWithRespectToProvince(
        orderData,
        'ZUEP',
        valueDevicePlan
      );
      deviceSalesTax = +_.get(valueDevice, provinceKey, 0);
      dueNowList.push({
        name: 'Device Sales Tax',
        price: deviceSalesTax,
        type: 'ADD'
      });
    } else if (valueDevicePlan === valueUnlimitedForBusiness) {
      const valueTierCode = getTierCode(fields);
      const valueHardwareCredit = +_.get(
        valueDevice,
        `${valueTierCode}_Hardware_credit`,
        0
      );
      /**
       * Calculating Easy Payment Cost
       */
      easyPaymentTotal =
        valueBibProgram === yes
          ? +_.get(valueDevice, `${valueTierCode}_WBIB_Monthly`, 0)
          : +_.get(valueDevice, `${valueTierCode}_WOBIB_Monthly`, 0);

      /**
       * Subtracting easypayment * 24monts price
       * from the Due now summary
       */
      if (valueContractTerm === valueTwoYear) {
        dueNowList.push({
          name: 'Easy Payment',
          price: (easyPaymentTotal * 24).toFixed(),
          type: 'SUB'
        });
      } else {
        dueNowList.push({
          name: 'Easy Payment',
          price: (easyPaymentTotal * 12).toFixed(),
          type: 'SUB'
        });
      }
      /**
       * Adding easypayment price
       * to the Due monthly summary
       */
      dueMonthlyList.push({
        name: 'Easy Payment',
        price: easyPaymentTotal,
        type: 'ADD'
      });
      /**
       * Calculating Device Upfront Cost
       */
      deviceUpfrontTotal =
        valueBibProgram === yes
          ? +_.get(valueDevice, `${valueTierCode}_WBIB_Upfront`, 0)
          : +_.get(valueDevice, `${valueTierCode}_WOBIB_Upfront`, 0);
      dueNowList.push({
        name: _.get(valueDevice, 'device_name', ''),
        price: _.get(valueDevice, 'mtmprice', 0),
        type: 'ADD',
        upfrontValue: deviceUpfrontTotal
      });
      /**
       * Calculating Device Sales Tax
       */
      deviceSalesTax = +_.get(
        valueDevice,
        getKeyWithRespectToProvince(orderData, valueTierCode),
        0
      );
      dueNowList.push({
        name: 'Device Sales Tax',
        price: deviceSalesTax,
        type: 'ADD'
      });

      /**
       * Adding Hardaware Credit to the due now summary if applies
       */
      if (valueHardwareCredit) {
        dueNowList.push({
          name: 'Hardware Credit',
          price: valueHardwareCredit,
          type: 'SUB'
        });
      }
      /**
       * Adding BIB Credit to the due now summary if applies
       */
      if (valueBibProgram === yes)
        dueNowList.push({
          name: 'Bring-it-Back Credit',
          price: valueBibCredit,
          type: 'SUB'
        });
    } else if (valueThreeYearHardwareCredit) {
      const valueTierCode = getTierCode(fields);

      const threeYearVoiceMonthlyEasyPayment = _.get(
        valueDevice,
        `${valueTierCode}_WOBIB_Monthly`,
        0
      );
      const threeYearVoiceMonthlyUpfront = _.get(
        valueDevice,
        `${valueTierCode}_WOBIB_Upfront`,
        0
      );
      dueMonthlyList.push({
        name: 'Easy Payment',
        price: threeYearVoiceMonthlyEasyPayment,
        type: 'ADD'
      });

      deviceSalesTax = +_.get(
        valueDevice,
        getKeyWithRespectToProvince(orderData, valueTierCode, '3 year'),
        0
      );
      dueNowList.push({
        name: 'Device Sales Tax',
        price: deviceSalesTax,
        type: 'ADD'
      });
      easyPaymentTotal = parseFloat(threeYearVoiceMonthlyEasyPayment);
      deviceUpfrontTotal = parseFloat(threeYearVoiceMonthlyUpfront);
    } else if (
      (contractTermTwoYearValueVariants.includes(valueContractTerm) &&
        devicePlanVoiceOnlyValueVariants.includes(valueDevicePlan)) ||
      devicePlanVoiceOnlyValueVariants.includes(valueTypeOfDevice) ||
      basicEasyPaymentVariants.includes(valueDevicePlan)
    ) {
      const twoYearVoiceMonthlyEasyPayment = _.get(
        valueDevice,
        `ZUEP_WOBIB_Monthly`,
        0
      );
      const twoYearVoiceMonthlyUpfront = _.get(
        valueDevice,
        `ZUEP_WOBIB_Upfront`,
        0
      );
      dueMonthlyList.push({
        name: 'Easy Payment',
        price: twoYearVoiceMonthlyEasyPayment,
        type: 'ADD'
      });
      deviceSalesTax = +_.get(
        valueDevice,
        contractTermThreeYearValueVariants.includes(valueContractTerm)
          ? getKeyWithRespectToProvince(orderData, 'ZUEP', '3 year')
          : getKeyWithRespectToProvince(orderData, 'ZUEP'),
        0
      );
      dueNowList.push({
        name: 'Device Sales Tax',
        price: deviceSalesTax,
        type: 'ADD'
      });
      easyPaymentTotal = parseFloat(twoYearVoiceMonthlyEasyPayment);
      deviceUpfrontTotal = parseFloat(twoYearVoiceMonthlyUpfront);
    } else {
      dueNowList.push({
        name: _.get(valueDevice, 'device_name', ''),
        price: _.get(valueDevice, 'mtmprice', 0),
        type: 'ADD',
        upfrontValue: _.get(valueDevice, 'mtmprice', 0)
      });
      deviceUpfrontTotal += +_.get(valueDevice, 'mtmprice', 0);
    }
  }

  if (isDevicesOnly) {
    deviceSalesTax = +_.get(
      valueDevice,
      getKeyWithRespectToProvince(orderData, 'ZUEP'),
      0
    );
    dueNowList.push({
      name: 'Device Sales Tax',
      price: deviceSalesTax,
      type: 'ADD'
    });
  }

  // 3 Year Contract Term
  // if (
  //   valueContractTerm === contractTerm3Year[0] ||
  //   valueContractTerm === contractTerm3Year[1]
  // ) {
  //   // Easy Payment Cost
  //   easyPaymentTotal = +valueEasyPaymentAmount;
  //   dueNowList.push({
  //     name: 'Easy Payment',
  //     price: easyPaymentTotal * 36,
  //     type: 'SUB'
  //   });
  //   dueMonthlyList.push({
  //     name: 'Easy Payment',
  //     price: easyPaymentTotal,
  //     type: 'ADD'
  //   });
  //   // Device Upfront Cost
  //   deviceUpfrontTotal = +valueUpfrontCost;
  //   dueNowList.push({
  //     name: 'Upfront Cost',
  //     price: deviceUpfrontTotal,
  //     type: 'ADD'
  //   });
  //   // deviceUpfrontTotal = deviceUpfrontTotal - easyPaymentTotal * 36;
  //   /**
  //    * Calculating Device Sales Tax
  //    */
  //   deviceSalesTax = +valueTaxes;
  //   dueNowList.push({
  //     name: 'Device Sales Tax',
  //     price: deviceSalesTax,
  //     type: 'ADD'
  //   });
  // }

  // DEVICE ENROLMENT
  if (
    valueDeviceEnrolment &&
    valueDeviceEnrolment !== 'None' &&
    valueDeviceEnrolment !== 'Aucune'
  ) {
    dueNowList.push({
      name: 'Device Enrolment',
      price: 20,
      type: 'ADD'
    });
    deviceUpfrontTotal += 20;
    deviceEnrolmentProgram = 20;
    deviceSalesTax +=
      (20 * provincesTaxPercentageMap[orderData.provinceWLS || '']) / 100;
  }

  // IS SIM REQUIRED DEVICES AND ACCESSORIES
  if (
    valueIsSimRequiredDevicesAccessories &&
    (valueIsSimRequiredDevicesAccessories === simRequiredEnglish ||
      valueIsSimRequiredDevicesAccessories === simRequiredFrench ||
      valueIsSimRequiredDevicesAccessories === eSimRequiredEnglish ||
      valueIsSimRequiredDevicesAccessories === eSimRequiredFrench)
  ) {
    deviceSalesTax +=
      (20 * provincesTaxPercentageMap[orderData.provinceWLS || '']) / 100;

    dueNowList.push({
      name: 'Sim',
      price: 20,
      type: 'ADD'
    });
    deviceUpfrontTotal += 20;

    simPrice = 20;
  }

  // DEVICE CREDIT
  if (valueDeviceCredit) {
    dueNowList.push({
      name: 'Device Credit',
      price: +valueDeviceCredit,
      type: 'SUB'
    });
    deviceUpfrontTotal -= +valueDeviceCredit;
  }
  /**
   * Adding the Accessories total
   */
  if (accessories.length > 0) {
    let valueAccessoriesTotal = 0;
    let valueAccessoriesTax = 0;
    accessories.forEach(accessory => {
      valueAccessoriesTotal += +accessory.price;
      valueAccessoriesTax += +accessory.tax;
      dueNowList.push({
        name: accessory.product,
        price: accessory.price,
        type: 'ADD'
      });
    });
    accessoriesPrice = valueAccessoriesTotal;
    deviceUpfrontTotal += valueAccessoriesTotal;
    deviceSalesTax += valueAccessoriesTax;
  }
  /**
   * Adding the Features total
   */
  let valueFeaturesTotal = 0;
  features.forEach(feature => {
    valueFeaturesTotal += +feature.price;
    dueMonthlyList.push({
      name: feature.name,
      price: feature.price,
      type: 'ADD'
    });
  });
  rateplanTotal += valueFeaturesTotal;

  /**
   * Adding the Device Care total
   */
  let valueDeviceCareTotal = 0;
  deviceCare.forEach(selection => {
    valueDeviceCareTotal += +selection.price;
    dueMonthlyList.push({
      name: selection.name,
      price: selection.price,
      type: 'ADD'
    });
  });
  rateplanTotal += valueDeviceCareTotal;

  let valueDeviceCareBYODTotal = 0;
  deviceCareBYOD.forEach(selection => {
    valueDeviceCareBYODTotal += +selection.price;
    dueMonthlyList.push({
      name: selection.name,
      price: selection.price,
      type: 'ADD'
    });
  });
  rateplanTotal += valueDeviceCareBYODTotal;

  deviceUpfrontCost = deviceUpfrontTotal;
  deviceUpfrontCost -= accessoriesPrice;
  taxes = deviceSalesTax;

  totalMonthly = rateplanTotal + easyPaymentTotal;
  totalOneTime = deviceUpfrontTotal + deviceSalesTax;

  // SOF-1766 (Upfront Cost -(enrollmant program cost + sim Required Cost))
  if (
    valueDeviceEnrolment &&
    valueDeviceEnrolment !== 'None' &&
    valueDeviceEnrolment !== 'Aucune'
  ) {
    deviceUpfrontCost -= 20;
  }
  if (
    valueIsSimRequiredDevicesAccessories &&
    (valueIsSimRequiredDevicesAccessories === simRequiredEnglish ||
      valueIsSimRequiredDevicesAccessories === simRequiredFrench ||
      valueIsSimRequiredDevicesAccessories === eSimRequiredEnglish ||
      valueIsSimRequiredDevicesAccessories === eSimRequiredFrench)
  ) {
    deviceUpfrontCost -= 20;
  }
  //////////////////

  const grandTotal = {
    rateplanTotal,
    easyPaymentTotal,
    deviceUpfrontTotal,
    deviceSalesTax,
    totalMonthly,
    totalOneTime
  };
  if (subscriberDetails.length > 0) {
    subscriberDetails.forEach(subscriberDetail => {
      /**
       * if editing subscriber then don't add it's amount from the subscribers array
       */
      if (
        !editingSubscriber ||
        (editingSubscriber &&
          editingSubscriber !== _.get(subscriberDetail, 'id', ''))
      ) {
        grandTotal.rateplanTotal += _.get(
          subscriberDetail,
          'total.rateplanTotal',
          0
        );
        grandTotal.easyPaymentTotal += _.get(
          subscriberDetail,
          'total.easyPaymentTotal',
          0
        );
        grandTotal.deviceUpfrontTotal += _.get(
          subscriberDetail,
          'total.deviceUpfrontTotal',
          0
        );
        grandTotal.deviceSalesTax += _.get(
          subscriberDetail,
          'total.deviceSalesTax',
          0
        );
        grandTotal.totalMonthly += _.get(
          subscriberDetail,
          'total.totalMonthly',
          0
        );
        grandTotal.totalOneTime += _.get(
          subscriberDetail,
          'total.totalOneTime',
          0
        );
      }
    });
  }
  setTotal({
    currentSubscriberTotal: {
      rateplanTotal,
      easyPaymentTotal,
      totalMonthly,
      deviceUpfrontTotal,
      deviceSalesTax
    },
    oneTimeCost: {
      simPrice,
      deviceEnrolmentProgram,
      accessoriesPrice,
      taxes,
      deviceUpfrontCost
    },
    grandTotal: { ...grandTotal },
    summary: {
      dueMonthlyList,
      dueNowList
    }
  });
};
